import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { LocalChannel } from '../../../interfaces/local-channel'
import { HTVButtonControllerDirective } from '../../../app-button-controller.directive'

@Component({
  selector: 'app-channel-selector',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './channel-selector.component.html',
  styleUrls: ['./channel-selector.component.scss'],
})
export class ChannelSelectorComponent implements OnInit {
  readonly DEFAULT_PLACEHOLDER = 'PAGES.CHANNEL_SELECTOR.SELECT_CHANNEL'

  @Input() channels: LocalChannel[] = []
  @Input() selectedChannel?: LocalChannel
  @Input() placeholder = this.DEFAULT_PLACEHOLDER
  @Output() channelSelected = new EventEmitter<LocalChannel>()

  showDropdown = false

  constructor(private appButtonDirective: HTVButtonControllerDirective) {}

  ngOnInit(): void {
    this.initializeSelectedChannel()
  }

  private initializeSelectedChannel(): void {
    if (!this.selectedChannel && this.channels.length > 0) {
      this.selectChannel(this.channels[0])
    }
  }

  selectPreviousChannel(): void {
    this.navigateChannel(-1)
  }

  selectNextChannel(): void {
    this.navigateChannel(1)
  }

  private navigateChannel(direction: number): void {
    if (this.channels.length === 0) return

    const currentIndex = this.getCurrentChannelIndex()
    const targetIndex = this.calculateTargetIndex(currentIndex, direction)
    this.selectChannel(this.channels[targetIndex])
  }

  private getCurrentChannelIndex(): number {
    if (!this.selectedChannel) return -1
    return this.channels.findIndex(c => c.id === this.selectedChannel?.id)
  }

  private calculateTargetIndex(currentIndex: number, direction: number): number {
    const channelCount = this.channels.length
    if (direction < 0) {
      return currentIndex <= 0 ? channelCount - 1 : currentIndex - 1
    } else {
      return (currentIndex + 1) % channelCount
    }
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown
    this.appButtonDirective.forceRefreshSelectedButton()
  }

  focusChannel(channel: LocalChannel): void {
    this.selectedChannel = channel
  }

  selectChannel(channel: LocalChannel): void {
    this.selectedChannel = channel
    this.channelSelected.emit(channel)
    this.closeDropdown()
  }

  private closeDropdown(): void {
    this.showDropdown = false
  }
}
